import { createContext, useContext, RefObject } from 'react'

type AnnotationsContextType = {
  annotationsCanvasRef: RefObject<HTMLDivElement | null> | null
  setIsResizing: (isResizing: boolean) => void
}

export const AnnotationsContext = createContext<AnnotationsContextType>({
  annotationsCanvasRef: null,
  setIsResizing: () => {},
})

export const useAnnotationsContext = () => useContext(AnnotationsContext)

export const AnnotationsProvider = ({
  children,
  annotationsCanvasRef,
  setIsResizing,
}: {
  children: React.ReactNode
  annotationsCanvasRef: RefObject<HTMLDivElement | null>
  setIsResizing: (isResizing: boolean) => void
}) => {
  return (
    <AnnotationsContext.Provider
      value={{
        setIsResizing,
        annotationsCanvasRef,
      }}
    >
      {children}
    </AnnotationsContext.Provider>
  )
}
